import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../search.module.scss'
import {
  FILTER_LEASE_TYPES,
  FILTER_LEASE_TYPES_BUSINESS,
  FILTER_LEASE_TYPES_PERSONAL,
} from '@/lib/constants'
import { storeSearchParameters } from '@/store/reducers/search'
import { selectSearchParametersFilterByParameter } from '@/store/selectors/search'
import { isProd } from '@/lib/utilities/system'

type LeaseTypeProps = {
  isMobile?: boolean
}

export const LeaseType = ({ isMobile = false }: LeaseTypeProps) => {
  const dispatch = useDispatch()
  const activeLeaseType = useSelector(state =>
    selectSearchParametersFilterByParameter(state, FILTER_LEASE_TYPES),
  )
  const [localActiveLeaseType, setLocalActiveLeaseType] = useState(activeLeaseType[0])

  useEffect(() => {
    setLocalActiveLeaseType(activeLeaseType[0])
  }, [activeLeaseType])

  const onChangeLeaseType = (
    newLeaseType: typeof FILTER_LEASE_TYPES_BUSINESS | typeof FILTER_LEASE_TYPES_PERSONAL,
  ) => {
    dispatch(
      storeSearchParameters({
        filter: FILTER_LEASE_TYPES,
        value: [newLeaseType],
      }),
    )
  }

  return (
    <div className={styles['filter-row']}>
      <div className={`${styles.values} ${styles.slider}`}>
        <input
          type="radio"
          id={`control-1-${isMobile ? 'mobile' : 'web'}`}
          name="tabs"
          className={`${localActiveLeaseType === FILTER_LEASE_TYPES_PERSONAL ? styles.active : ''}${!isProd() ? ' search__filter-personal-input' : ''}`}
          value={FILTER_LEASE_TYPES_PERSONAL}
          onChange={() => onChangeLeaseType(FILTER_LEASE_TYPES_PERSONAL)}
        />
        <label
          className={styles.tab}
          onClick={() => setLocalActiveLeaseType(FILTER_LEASE_TYPES_PERSONAL)}
          htmlFor={`control-1-${isMobile ? 'mobile' : 'web'}`}>
          Personal
        </label>
        <input
          type="radio"
          id={`control-2-${isMobile ? 'mobile' : 'web'}`}
          name="tabs"
          className={`${localActiveLeaseType === FILTER_LEASE_TYPES_BUSINESS ? styles.active : ''}${!isProd() ? ' search__filter-business-input' : ''}`}
          value={FILTER_LEASE_TYPES_BUSINESS}
          onChange={() => onChangeLeaseType(FILTER_LEASE_TYPES_BUSINESS)}
        />
        <label
          className={styles.tab}
          onClick={() => setLocalActiveLeaseType(FILTER_LEASE_TYPES_BUSINESS)}
          htmlFor={`control-2-${isMobile ? 'mobile' : 'web'}`}>
          Business
        </label>
        <span className={styles.glider}></span>
      </div>
    </div>
  )
}
